module.exports = __webpack_public_path__ + "media/images/icon/icons8-Expired-11ca6f4c8e2ef4e2619f9f3efbb21633.png";